<template>
  <div class="detail-page">
    <div class="layout__content__content pt-5">
      <AppLoader />
      <p class="mt-2 text-primary font-weight-bolder">
        {{ $t("prilasujiUzivatele") }}
      </p>
    </div>
  </div>
</template>
<script>
import mgr from "@/services/security.js"
import Loader from "@/components/loader.vue"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    AppLoader: Loader
  },
  async created() {
    const authStore = useAuthStore()
    const configStore = useConfigStore()
    try {
      const user = await mgr.signinRedirectCallback()
      authStore.setAxiosHeaders(user)
      let returnPath
      try {
        const parsed = JSON.parse(user.state)
        // New format: { returnPath: "/path" }. Legacy format: bare string "/path".
        returnPath = typeof parsed === "object" && parsed !== null ? parsed.returnPath : parsed
      } catch {
        // user.state is not JSON (legacy bare-string redirect from before the deploy)
        returnPath = user.state
      }
      // returnPath was persisted in localStorage as a backup; consume it now.
      localStorage.removeItem("returnPath")
      this.$router.push(typeof returnPath === "string" && returnPath ? returnPath : "/")
    } catch (e) {
      console.error(e)
      configStore.isLoginErrorVisible = true
    }
  }
}
</script>
